module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // define __esModule on exports

  /******/


  __webpack_require__.r = function (exports) {
    /******/
    if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/
      Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/


    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/

  /******/
  // create a fake namespace object

  /******/
  // mode & 1: value is a module id, require it

  /******/
  // mode & 2: merge all properties of value into the ns

  /******/
  // mode & 4: return value when already ns object

  /******/
  // mode & 8|1: behave like require

  /******/


  __webpack_require__.t = function (value, mode) {
    /******/
    if (mode & 1) value = __webpack_require__(value);
    /******/

    if (mode & 8) return value;
    /******/

    if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
    /******/

    var ns = Object.create(null);
    /******/

    __webpack_require__.r(ns);
    /******/


    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/

    if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    /******/

    return ns;
    /******/
  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = "./src/index.js");
  /******/
}(
/************************************************************************/

/******/
{
  /***/
  "./src/index.js":
  /*!**********************!*\
    !*** ./src/index.js ***!
    \**********************/

  /*! exports provided: default */

  /***/
  function srcIndexJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utils */ \"./src/utils.js\");\nfunction _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }\n\n\n\nif (typeof window.RunningExperiments !== \"object\") {\n  window.RunningExperiments = {};\n}\n\nconst shareExperimentMetadata = (experimentName, variantName) => {\n  window.RunningExperiments[experimentName] = variantName;\n\n  if (window.dataLayer) {\n    window.dataLayer.push({\n      [experimentName]: variantName\n    });\n  }\n};\n\nclass Experiments {\n  constructor(experimentConfigs = []) {\n    _defineProperty(this, \"payloads\", {});\n\n    experimentConfigs.forEach(experiment => {\n      const variant = this.getVariant(experiment);\n      this.payloads[experiment.name] = variant.payload;\n      shareExperimentMetadata(experiment.name, variant.name);\n    });\n  }\n\n  getVariant(exp) {\n    const {\n      variants,\n      name\n    } = exp;\n    let variantId = Object(_utils__WEBPACK_IMPORTED_MODULE_0__[\"readKey\"])(name);\n\n    if (!variantId || !variants[variantId]) {\n      variantId = Math.floor(Object(_utils__WEBPACK_IMPORTED_MODULE_0__[\"random\"])() * variants.length);\n      Object(_utils__WEBPACK_IMPORTED_MODULE_0__[\"writeKey\"])(name, variantId);\n    }\n\n    const variant = variants[variantId];\n    return variant;\n  }\n\n  getPayload(name) {\n    return this.payloads[name];\n  }\n\n}\n\n/* harmony default export */ __webpack_exports__[\"default\"] = (Experiments);\n\n//# sourceURL=webpack:///./src/index.js?");
    /***/
  },

  /***/
  "./src/utils.js":
  /*!**********************!*\
    !*** ./src/utils.js ***!
    \**********************/

  /*! exports provided: readKey, writeKey, random */

  /***/
  function srcUtilsJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"readKey\", function() { return readKey; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"writeKey\", function() { return writeKey; });\n/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, \"random\", function() { return random; });\nfunction readKey(name) {\n  if (window.localStorage) {\n    return window.localStorage.getItem(`FEX_${name}`);\n  } else if (document) {\n    return readCookie(`FEX_${name}`);\n  } else {\n    return null;\n  }\n}\nfunction writeKey(name, value) {\n  if (window.localStorage) {\n    window.localStorage.setItem(`FEX_${name}`, value);\n  } else if (document) {\n    writeCookie(`FEX_${name}`, value);\n  }\n}\n\nfunction readCookie(name) {\n  var nameEQ = name + \"=\",\n      ca = document.cookie.split(\";\") || \"\",\n      i,\n      c;\n\n  for (i = 0; i < ca.length; i++) {\n    c = ca[i];\n\n    while (c.charAt(0) === \" \") {\n      c = c.substring(1, c.length);\n    }\n\n    if (c.indexOf(nameEQ) === 0) {\n      return c.substring(nameEQ.length, c.length);\n    }\n  }\n\n  return null;\n}\n\nfunction writeCookie(name, value) {\n  document.cookie = `${name}=${value}; path=/`;\n}\n\nconst rndArray = new Uint32Array(1);\nconst random = () => crypto && crypto.getRandomValues ? crypto.getRandomValues(rndArray)[0] / 4294967295 : Math.random();\n\n//# sourceURL=webpack:///./src/utils.js?");
    /***/
  }
  /******/

});